import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';

const CustomInput = ({
  label,
  fieldStylesClass,
  labelStylesClass,
  errorStylesClass,
  inputComponentType,
  inputStylesClass,
  type,
  handleFieldChange,
  ...props
}) => {
  const [field, meta] = useField(props);
  const Input = inputComponentType;
  return (
    <label className={fieldStylesClass}>
      {handleFieldChange ? (
        <Input
          {...props}
          {...field}
          {...type}
          onChange={(e) => {
            handleFieldChange(e, field);
            return field.onChange(e);
          }}
          data-empty={field.value === ''}
          className={inputStylesClass}
        />
      ) : (
        <Input
          {...props}
          {...field}
          {...type}
          data-empty={field.value === ''}
          className={inputStylesClass}
        />
      )}
      <div
        className={labelStylesClass}
        dangerouslySetInnerHTML={{ __html: label }}
      />
      {meta.touched && meta.error && (
        <div className={errorStylesClass}>{meta.error}</div>
      )}
    </label>
  );
};

CustomInput.defaultProps = {
  inputComponentType: 'input',
  placeholder: '',
  type: 'text',
};

CustomInput.propTypes = {
  label: PropTypes.string,
  fieldStylesClass: PropTypes.string,
  labelStylesClass: PropTypes.string,
  errorStylesClass: PropTypes.string,
  inputStylesClass: PropTypes.string,
  inputComponentType: PropTypes.string,
  handleFieldChange: PropTypes.func,
  type: PropTypes.string,
};

export default CustomInput;
